@if (this.text(); as text) {
  <span class="cell-text">{{ text }}</span>
}
@if (this.html(); as html) {
  <span class="cell-html" [innerHTML]="html"></span>
}
<ng-container #outlet></ng-container>
